import React, { useState } from 'react';

const AddWordForm = ({ onAdd }) => {
  const [word, setWord] = useState('');
  const [translation, setTranslation] = useState('');
  const [topic, setTopic] = useState('');
  const [errors, setErrors] = useState({ word: false, translation: false });

  const handleSubmit = (e) => {
    e.preventDefault();

    
    if (!word || !translation) {
      setErrors({
        word: !word,
        translation: !translation,
      });
      return;
    }

  
    onAdd({ word, translation, topic });
    setWord('');
    setTranslation('');
    setTopic('');
    setErrors({ word: false, translation: false });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="word">Mot</label>
        <input
          id="word"
          type="text"
          value={word}
          onChange={(e) => setWord(e.target.value)}
          className={errors.word ? 'error' : ''}
        />
        {errors.word && <span className="error-message">Le champ ne peut pas être vide</span>}
      </div>

      <div>
        <label htmlFor="translation">Traduction</label>
        <input
          id="translation"
          type="text"
          value={translation}
          onChange={(e) => setTranslation(e.target.value)}
          className={errors.translation ? 'error' : ''}
        />
        {errors.translation && <span className="error-message">Le champ ne peut pas être vide</span>}
      </div>

      <div>
        <label htmlFor="topic">Thème</label>
        <input
          id="topic"
          type="text"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
        />
      </div>

      <button type="submit" disabled={!word || !translation}>
        Ajouter un mot
      </button>
    </form>
  );
};

export default AddWordForm;
